<!-- 

CONFIGURAÇÃO DE PAGAMENTOS ON LINE

-->

<script>
import { SysVars } from '../main';
import Vue from 'vue';

export default {
    props: {
        parametros: { type: Object },
    },

    components: {
    },

    data () {
        return {
            editingBandeiras : false,
            editingBandeirasObj: null,
            showConfigBrand: false
        }
    },

    computed: {

    },

    filters: {

    },

    methods: {
        hanleShowConfigBrand(){
            console.log(`entrou`)
            this.showConfigBrand = !this.showConfigBrand
        },
        handleDesativar (operadora) {
            if (operadora == 'bandeiras') {
                this.parametros.rodape.habilitaBandeiras = false;
            }
            this.$emit('saveconfig')
        },

        handleAtivar (operadora) {
            if (operadora == 'bandeiras') {
                this.editingBandeiras = true
                if (!this.parametros.rodape.bandeiras)
                    this.parametros.rodape.bandeiras = { boleto: true, visa: true, mcard: true, elo: true, american_express: true, dinners_club: true, hipercard: true, jcb: true, discover: true, aura: true }
                this.editingBandeirasObj = {...this.parametros.rodape.bandeiras} 
            }
        },
        handleSalvarBandeiras () {
            this.parametros.rodape.habilitaBandeiras = true
            this.editingBandeiras = true
            this.editingBandeiras = false
            this.$emit('saveconfig')
        },

        handleCancelarBandeiras () {
            this.parametros.rodape.bandeiras = this.editingBandeirasObj
            this.editingBandeiras = false
            // this.$emit('saveconfig')
        },

        handleEditBandeiras () {
            this.editingBandeirasObj = {...this.parametros.rodape.bandeiras}
            this.editingBandeiras = true            
        }



    },

    watch: {

    },

    mounted () {

    },

    created () {
    }

}

</script>

<template>

  <div class="mb-2 container-accordion" :class="showConfigBrand ? 'container-open' : 'container-close'">

    <div class="row mb-2 cursor-pointer" @click="hanleShowConfigBrand">
        <div class="col-11">
            <span class="lbl-deal-title mb-3">Imagens Bandeiras de cartões</span>
            <br>
            <span>Configure as bandeiras de cartões exibidas no rodapé da sua loja!</span>
        </div>
        <button class="col-auto border-0 bg-transparent" style="outline: none">
            <i :class="'text-secondary fa fa-chevron-' + (showConfigBrand ? 'up' : 'down') "></i>
        </button>
    </div>
    
    <div>
        <div class="border p-3 mb-2" >
            <!-- bandeiras rodape -->
            <div class="row mb-2">
                <div class="col-12">
                    <span class="badge badge-success" v-if="parametros.rodape.habilitaBandeiras">Ativado</span>
                </div>
            </div>
            <div class="row" v-if="!parametros.rodape.habilitaBandeiras && !editingBandeiras">
                <div class="col-md-12">
                    <label class="lbl-edit">                    
                    Habilitar imagens das bandeiras no final da página
                    </label>
                </div>
                <div class="col-md-12">
                    <v-button label="Ativar" :success="true" @click="handleAtivar('bandeiras')"></v-button>
                </div>
            </div>
            <div class="row mt-3" v-if="parametros.rodape.habilitaBandeiras || editingBandeiras">
                <div class="col-md-12 mb-2">
                    <label class="lbl-edit d-flex" style="gap:10px">
                        <div>
                            <i class="fa fa-times" :class="!editingBandeiras ? 'text-secondary' :'text-danger'" for="Boleto" v-if="!parametros.rodape.bandeiras.boleto" ></i>                    
                            <i class="fa fa-check" :class="!editingBandeiras ? 'text-secondary' :'text-success'" for="Boleto" v-else></i>                    
                        </div>
                        <input type="checkbox" id="Boleto" name="Boleto" v-model="parametros.rodape.bandeiras.boleto" :disabled="!editingBandeiras" v-show="false">
                        <img src="https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/bandeiras/boleto.svg" class="bandeira"> Boleto
                    </label>
                </div>

                <div class="col-md-12 mb-2">
                    <label class="lbl-edit d-flex" style="gap:10px">
                        <div>
                            <i class="fa fa-times" :class="!editingBandeiras ? 'text-secondary' :'text-danger'" for="Visa" v-if="!parametros.rodape.bandeiras.visa" ></i>                    
                            <i class="fa fa-check" :class="!editingBandeiras ? 'text-secondary' :'text-success'" for="Visa" v-else></i>                    
                        </div>
                        <input type="checkbox" id="Visa" name="Visa" v-model="parametros.rodape.bandeiras.visa" :disabled="!editingBandeiras" v-show="false">
                        <img src="https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/bandeiras/visa.svg" class="bandeira"> Visa
                    </label>
                </div>


                <div class="col-md-12 mb-2">
                    <label class="lbl-edit d-flex" style="gap:10px">
                        <div>
                            <i class="fa fa-times" :class="!editingBandeiras ? 'text-secondary' :'text-danger'" for="Mastercard" v-if="!parametros.rodape.bandeiras.mcard" ></i>                    
                            <i class="fa fa-check" :class="!editingBandeiras ? 'text-secondary' :'text-success'" for="Mastercard" v-else></i>                    
                        </div>
                        <input type="checkbox" id="Mastercard" name="Mastercard" v-model="parametros.rodape.bandeiras.mcard" :disabled="!editingBandeiras" v-show="false">
                        <img src="https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/bandeiras/mcard.svg" class="bandeira"> Mastercard
                    </label>
                </div>


                <div class="col-md-12 mb-2">
                    <label class="lbl-edit d-flex" style="gap:10px">
                        <div>
                            <i class="fa fa-times" :class="!editingBandeiras ? 'text-secondary' :'text-danger'" for="Elo" v-if="!parametros.rodape.bandeiras.elo" ></i>                    
                            <i class="fa fa-check" :class="!editingBandeiras ? 'text-secondary' :'text-success'" for="Elo" v-else></i>                    
                        </div>
                        <input type="checkbox" id="Elo" name="Elo" v-model="parametros.rodape.bandeiras.elo" :disabled="!editingBandeiras" v-show="false">
                        <img src="https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/bandeiras/elo.svg" class="bandeira"> Elo
                    </label>
                </div>


                <div class="col-md-12 mb-2">
                    <label class="lbl-edit d-flex" style="gap:10px">
                        <div>
                            <i class="fa fa-times" :class="!editingBandeiras ? 'text-secondary' :'text-danger'" for="Express" v-if="!parametros.rodape.bandeiras.american_express" ></i>                    
                            <i class="fa fa-check" :class="!editingBandeiras ? 'text-secondary' :'text-success'" for="Express" v-else></i>                    
                        </div>
                        <input type="checkbox" id="Express" name="Express" v-model="parametros.rodape.bandeiras.american_express" :disabled="!editingBandeiras" v-show="false">
                        <img src="https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/bandeiras/american-express.svg" class="bandeira"> American Express
                    </label>
                </div>


                <div class="col-md-12 mb-2">
                    <label class="lbl-edit d-flex" style="gap:10px">
                        <div>
                            <i class="fa fa-times" :class="!editingBandeiras ? 'text-secondary' :'text-danger'" for="club" v-if="!parametros.rodape.bandeiras.dinners_club" ></i>                    
                            <i class="fa fa-check" :class="!editingBandeiras ? 'text-secondary' :'text-success'" for="club" v-else></i>                    
                        </div>
                        <input type="checkbox" id="club" name="club" v-model="parametros.rodape.bandeiras.dinners_club" :disabled="!editingBandeiras" v-show="false">
                        <img src="https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/bandeiras/dinners-club.svg" class="bandeira"> Dinners club
                    </label>
                </div>

                <div class="col-md-12 mb-2">
                    <label class="lbl-edit d-flex" style="gap:10px">
                        <div>
                            <i class="fa fa-times" :class="!editingBandeiras ? 'text-secondary' :'text-danger'" for="Hipercard" v-if="!parametros.rodape.bandeiras.hipercard" ></i>                    
                            <i class="fa fa-check" :class="!editingBandeiras ? 'text-secondary' :'text-success'" for="Hipercard" v-else></i>                    
                        </div>
                        <input type="checkbox" id="Hipercard" name="Hipercard" v-model="parametros.rodape.bandeiras.hipercard" :disabled="!editingBandeiras" v-show="false">
                        <img src="https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/bandeiras/hipercard.svg" class="bandeira"> Hipercard
                    </label>
                </div>


    <!--             <div class="col-md-12 mb-2">
                    <label class="lbl-edit d-flex" style="gap:10px">
                        <div>
                            <i class="fa fa-times" :class="!editingBandeiras ? 'text-secondary' :'text-danger'" for="JCB" v-if="!parametros.rodape.bandeiras.jcb" ></i>                    
                            <i class="fa fa-check" :class="!editingBandeiras ? 'text-secondary' :'text-success'" for="JCB" v-else></i>                    
                        </div>
                        <input type="checkbox" id="JCB" name="JCB" v-model="parametros.rodape.bandeiras.jcb" :disabled="!editingBandeiras" v-show="false">
                        <img src="jcb.svg" class="bandeira"> JCB
                    </label>
                </div>


                <div class="col-md-12 mb-2">
                    <label class="lbl-edit d-flex" style="gap:10px">
                        <div>
                            <i class="fa fa-times" :class="!editingBandeiras ? 'text-secondary' :'text-danger'" for="Discover" v-if="!parametros.rodape.bandeiras.discover" ></i>                    
                            <i class="fa fa-check" :class="!editingBandeiras ? 'text-secondary' :'text-success'" for="Discover" v-else></i>                    
                        </div>
                        <input type="checkbox" id="Discover" name="Discover" v-model="parametros.rodape.bandeiras.discover" :disabled="!editingBandeiras" v-show="false">
                        <img src="discover.svg" class="bandeira"> Discover
                    </label>
                </div>
    -->

                <div class="col-md-12 mb-2">
                    <label class="lbl-edit d-flex" style="gap:10px">
                        <div>
                            <i class="fa fa-times" :class="!editingBandeiras ? 'text-secondary' :'text-danger'" for="Aura" v-if="!parametros.rodape.bandeiras.aura" ></i>                    
                            <i class="fa fa-check" :class="!editingBandeiras ? 'text-secondary' :'text-success'" for="Aura" v-else></i>                    
                        </div>
                        <input type="checkbox" id="Aura" name="Aura" v-model="parametros.rodape.bandeiras.aura" :disabled="!editingBandeiras" v-show="false">
                        <img src="https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/bandeiras/aura.svg" class="bandeira"> Aura
                    </label>
                </div>




                <div class="col-md-12 mt-3" v-if="editingBandeiras">
                    <v-button label="Salvar" :success="true" @click="handleSalvarBandeiras"></v-button>
                    <v-button label="Cancelar" @click="handleCancelarBandeiras"></v-button>
                </div>
                <div class="col-md-12 mt-3" v-if="parametros.rodape.habilitaBandeiras && !editingBandeiras">
                    <v-button label="Desativar" :danger="true" @click="handleDesativar('bandeiras')"></v-button>
                    <v-button icon="fa-pencil" label="Editar" @click="handleEditBandeiras"></v-button>
                </div>
            </div>
        </div>
    </div>

  </div>

</template>

<style scoped>

.bandeira{
    height: 20px;
    width: 30px;
}
.container-accordion{
    transition: overflow 0.s;
    transition: all .4s;
    overflow-x: hidden;
}
.container-open{
    overflow-y: hidden;
    max-height: 900px;
}
.container-close{
    transition: overflow 0.s;
    overflow-y: hidden;
    max-height: 50px;
}
.accordion{
    transition: opacity .4s linear ;
}
.open{
    opacity: 100%;
}
.close{
    opacity: 0;
}

</style>



// WEBPACK FOOTER //
// src/forms-loja/config-bandeiras-form-loja.vue